import CircularProgress from "@material-ui/core/CircularProgress";
import PropTypes from "prop-types";

const Loader = (props) => {
    return (
        <CircularProgress
            style={{
                color: props.color,
                height: props.height,
                width: props.width,
            }}
        />
    );
};

Loader.defaultProps = {
    height: "50px",
    width: "50px",
    color: "gray",
};

Loader.propTypes = {
    height: PropTypes.string,
    width: PropTypes.string,
    color: PropTypes.string,
};

export default Loader;
